import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route, useNavigate, useLocation, useParams } from 'react-router-dom';
import { HelmetProvider, Helmet } from 'react-helmet-async';

// --- تغییر مسیر ایمپورت‌ها به پوشه Subprogram ---
import HeaderNavigation from './Subprogram/HeaderNavigation';
import Home from './Subprogram/Home';
import AboutUs from './Subprogram/AboutUs';
import News from './Subprogram/News';
import ProductPage from './Subprogram/ProductPage';
import FreeDiscussion from './Subprogram/FreeDiscussion';
import FreeApps from './Subprogram/FreeApp';
import LoginAdmin from './Subprogram/LoginAdmin';
import SafeTraining from './Subprogram/SafeTraining';
import IdeaStaticaTraining from './Subprogram/IdeaStaticaTraining'; 
import EtabsTraining from './Subprogram/EtabsTraining';
import EtabsConcreteTraining from './Subprogram/EtabsConcreteTraining';
import RhinoGrasshopperTraining from './Subprogram/RhinoGrasshopperTraining';
import ResellerPanel from './Subprogram/ResellerPanel';
import ActivationForm from './Subprogram/ActivationForm';

// اضافه کردن به بقیه وضعیت‌های بالا در App.jsx

// --- Version Control ---
const APP_VERSION = 'v2.2';

// --- API Configuration ---
const API_BASE = 'https://arkaniomran.ir/api'; 

// --- Icons ---
const Icons = {
  Lock: ({ size = 16, className, onClick }) => <svg onClick={onClick} xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>,
  Trash2: ({ size = 16, className }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line></svg>,
  Send: ({ size = 16, className }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon></svg>,
  MessageSquare: ({ size = 16, className }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path></svg>,
  User: ({ size = 16, className }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle></svg>,
  X: ({ size = 16, className, onClick }) => <svg onClick={onClick} xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>,
  FileText: ({ size = 16, className }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>,
  Menu: ({ size = 24, className }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line></svg>,
  ChevronLeft: ({ size = 16, className }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M15 18l-6-6 6-6" /></svg>,
  CheckCircle: ({ size = 16, className }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>,
  Loader: ({ size = 16, className }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={`${className} animate-spin`}><path d="M21 12a9 9 0 1 1-6.219-8.56" /></svg>,
  LogOut: ({ size = 16, className }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line></svg>,
  Settings: ({ size = 16, className }) => <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82 .33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path></svg>,
  Eye: ({ size = 16, className, onClick }) => <svg onClick={onClick} xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle></svg>,
  EyeOff: ({ size = 16, className, onClick }) => <svg onClick={onClick} xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line></svg>
};


// ==============================
// نگاشت شناسه هر صفحه به آدرس (URL) واقعی آن
// هر کلید همان مقداری است که قبلاً به activePage داده می‌شد
// ==============================
const PAGE_ROUTES = {
  'home': '/',
  'etabs-training': '/etabs-training',
  'etabs-concrete-training': '/etabs-concrete-training',
  'safe-training': '/safe-training',
  'IdeaStatica-training': '/idea-statica-training',
  'rhino-training': '/rhino-training',
  'about': '/about',
  'news': '/news',
  'forum': '/forum',
  'free-apps': '/free-apps',
  'admin-panel': '/admin-panel',
  'activation': '/activation',
  'reseller-panel': '/reseller-panel',
  'betonica': '/products/betonica',
  'steelica': '/products/steelica',
  'seismica': '/products/seismica',
  'etanex': '/products/etanex',
  'wallica': '/products/wallica',
  'structica': '/products/structica',
  'std2800': '/products/std2800',
};

// ==============================
// عنوان و توضیحات مخصوص هر صفحه برای سئو (Title / Meta Description)
// این متن‌ها را می‌توانید بعداً هرطور خواستید ویرایش کنید
// ==============================
const SEO_META = {
  'home': {
    title: 'ارکانی عمران | نرم‌افزارهای تخصصی مهندسی عمران',
    description: 'ارکانی عمران ارائه‌دهنده نرم‌افزارهای تخصصی مهندسی عمران، آموزش ایتبس، سیف و آیدیا استاتیکا و ابزارهای رایگان محاسباتی.'
  },
  'etabs-training': {
    title: 'آموزش جامع ایتبس فولادی | ارکانی عمران',
    description: 'آموزش رایگان و کامل نرم‌افزار ایتبس (ETABS) برای طراحی سازه فولادی از صفر تا صد، همراه فایل‌های تمرینی.'
  },
  'etabs-concrete-training': {
    title: 'آموزش جامع ایتبس بتنی | ارکانی عمران',
    description: 'آموزش رایگان و کامل نرم‌افزار ایتبس (ETABS) برای طراحی سازه بتن‌آرمه از صفر تا صد، همراه فایل‌های تمرینی.'
  },
  'safe-training': {
    title: 'آموزش جامع نرم‌افزار SAFE | ارکانی عمران',
    description: 'آموزش رایگان و کامل نرم‌افزار SAFE از تهیه گزارش ژئوتکنیک تا کنترل‌های مورد نیاز، همراه فایل‌های تمرینی.'
  },
  'IdeaStatica-training': {
    title: 'آموزش جامع نرم‌افزار IDEA StatiCa | ارکانی عمران',
    description: 'آموزش رایگان نرم‌افزار IDEA StatiCa همراه با جزوه، فایل‌های آیین‌نامه‌ای و فایل‌های تمرینی هر جلسه.'
  },
  'rhino-training': {
    title: 'آموزش راینو و گرس‌هاپر | ارکانی عمران',
    description: 'آموزش رایگان راینو (Rhino) و گرس‌هاپر (Grasshopper) ویژه معماران و مهندسان عمران؛ سازه‌های خاص و خرپای فضایی با Karamba3D و StructiCa.'
  },
  'about': {
    title: 'درباره ما | ارکانی عمران',
    description: 'آشنایی با کیارش ارکانی، مدیر و موسس ارکانی عمران و طراح نرم‌افزارهای تخصصی مهندسی عمران.'
  },
  'news': {
    title: 'اخبار و اطلاعیه‌ها | ارکانی عمران',
    description: 'آخرین اخبار، اطلاعیه‌ها و به‌روزرسانی‌های نرم‌افزارها و دوره‌های آموزشی ارکانی عمران.'
  },
  'forum': {
    title: 'تالار گفت‌و‌گو | ارکانی عمران',
    description: 'تالار گفت‌و‌گوی کاربران ارکانی عمران برای پرسش، پاسخ و به اشتراک‌گذاری تجربیات مهندسی.'
  },
  'free-apps': {
    title: 'برنامه‌های رایگان محاسباتی عمران | ارکانی عمران',
    description: 'مجموعه ابزارهای آنلاین و رایگان محاسباتی مهندسی عمران شامل طراحی جوش، برش، خمش و کنترل‌های آیین‌نامه‌ای.'
  },
  'activation': {
    title: 'فعال‌سازی EtaNex | ارکانی عمران',
    description: 'فرم فعال‌سازی نرم‌افزار EtaNex ارکانی عمران.'
  },
  'admin-panel': {
    title: 'پنل مدیریت | ارکانی عمران',
    description: 'پنل مدیریت داخلی ارکانی عمران.'
  },
  'reseller-panel': {
    title: 'پنل نمایندگان | ارکانی عمران',
    description: 'پنل ویژه نمایندگان فروش ارکانی عمران.'
  },
  'betonica': { title: 'نرم‌افزار بتنیکا BetoniCa V2.5 | طراحی بتن‌آرمه، ترسیم در AutoCAD و دریافت مدل از SAFE | ارکانی عمران', description: 'دانلود و خرید نرم‌افزار بتنیکا (BetoniCa V2.5) برای طراحی و کنترل سازه بتن‌آرمه طبق مبحث نهم؛ ترسیم فونداسیون، دیوار برشی، دال و تیرچه‌بلوک در AutoCAD و دریافت گرید، ستون‌ها و پلان پی از مدل SAFE.' },
  'steelica': { title: 'نرم‌افزار استیلیکا SteeliCa V2.2 | طراحی ستون مرکب و سازه فولادی طبق مبحث دهم | ارکانی عمران', description: 'دانلود و خرید نرم‌افزار استیلیکا (SteeliCa V2.2): طراحی ستون مرکب SRC و CFT، اتصالات، بیس‌پلیت و مهاربند فولادی طبق مبحث دهم مقررات ملی، با ترسیم در AutoCAD و گزارش PDF، Word و Excel.' },
  'seismica': { title: 'نرم‌افزار SeismiCa | ارکانی عمران', description: 'دانلود و خرید لایسنس نرم‌افزار SeismiCa برای تحلیل و کنترل لرزه‌ای سازه.' },
  'etanex': { title: 'ایتانکس EtaNex V2.4.1 | کنترل دریفت ایتبس طبق استاندارد ۲۸۰۰ ویرایش ۵ | ارکانی عمران', description: 'نرم‌افزار ایتانکس (EtaNex V2.4.1): کنترل دریفت طبقات، نامنظمی پیچشی و شاخص پایداری P-Delta مستقیماً روی مدل ETABS مطابق استاندارد ۲۸۰۰ ویرایش ۵؛ همراه با نمودار دریفت، بررسی خودکار ترکیب بارها محاسبه بار برف و باد (مبحث ششم) و کنترل دیافراگم.' },
  'wallica': { title: 'نرم‌افزار والیکا WalliCa V2.0 | طراحی وال‌پست و دیوار غیرسازه‌ای و ترسیم در AutoCAD | ارکانی عمران', description: 'دانلود و خرید نرم‌افزار والیکا (WalliCa V2.0): طراحی و محاسبه وال‌پست و دیوارهای غیرسازه‌ای طبق راهنمای اجزای غیرسازه‌ای ۱۴۰۵، محاسبه هم‌زمان باد و زلزله، میلگرد بستر و وال‌مش و ترسیم خودکار دیوار در AutoCAD.' },
  'structica': { title: 'نرم‌افزار StructiCa استراکتیکا | تحلیل و طراحی خرپای فضایی در راینو | ارکانی عمران', description: 'دانلود و خرید نرم‌افزار استراکتیکا (StructiCa V1.0) برای تحلیل و طراحی سازه خرپای فضایی سه‌بعدی و قاب با اتصال مستقیم به Rhino؛ تحلیل استاتیکی، مودال و کنترل ظرفیت.' },
  'std2800': { title: 'استاندارد ۲۸۰۰ - نسخه ۵ | ارکانی عمران', description: 'ابزار کنترل و طراحی بر اساس استاندارد ۲۸۰۰ ویرایش پنجم.' },
};

// تابع کمکی: از روی مسیر فعلی (pathname)، شناسه صفحه را پیدا می‌کند
const getPageIdFromPath = (pathname) => {
  const found = Object.entries(PAGE_ROUTES).find(([, path]) => path === pathname);
  return found ? found[0] : 'home';
};

// کامپوننت کمکی برای صفحات محصول: پارامتر productName را از آدرس می‌خواند
const ProductPageRoute = ({ Icons }) => {
  const { productName } = useParams();
  return <ProductPage isVisible={true} productName={productName} Icons={Icons} />;
};

const AppContent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const activePage = getPageIdFromPath(location.pathname);

  const [mobileMenuHidden, setMobileMenuHidden] = useState(true);
  const [user, setUser] = useState(null);
  const [userProfile, setUserProfile] = useState(null);
  const [news, setNews] = useState([]);
  const [comments, setComments] = useState([]);
  const [isLoadingData, setIsLoadingData] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isNewsSubmitting, setIsNewsSubmitting] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authMode, setAuthMode] = useState('login'); // 'login', 'signup', 'forgot'
  const [authEmail, setAuthEmail] = useState('');
  const [authPassword, setAuthPassword] = useState('');
  const [authUsername, setAuthUsername] = useState(''); // full_name در دیتابیس
  const [authLoading, setAuthLoading] = useState(false);
  const [authShowPass, setAuthShowPass] = useState(false);

  // --- تنظیمات عنوان سایت و آیکون مرورگر ---
  useEffect(() => {
    document.title = "Arkani Omran/ ارکانی عمران";
    const logoUrl = "https://arkaniomran.ir/favicon.ico";
    const updateIcon = () => {
      const existingIcons = document.querySelectorAll("link[rel*='icon']");
      existingIcons.forEach(el => el.remove());
      const link = document.createElement('link');
      link.type = 'image/x-icon';
      link.rel = 'shortcut icon';
      link.href = logoUrl;
      document.getElementsByTagName('head')[0].appendChild(link);
    };
    updateIcon();
  }, []);

  // --- Navigation Handler ---
  // به جای query string (?page=xxx) حالا از مسیر واقعی (real URL path) استفاده می‌کنیم
  const handleNavigate = (page, section = null) => {
    const path = PAGE_ROUTES[page] || '/';
    if (location.pathname !== path) {
      navigate(path);
    }
    setMobileMenuHidden(true);
    if (section) {
      setTimeout(() => {
        const el = document.getElementById(section);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 150);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  // سازگاری با لینک‌های قدیمی: اگر کسی از طریق لینک قدیمی ?page=xxx وارد سایت شود
  // به آدرس جدید و واقعی هدایتش می‌کنیم (Redirect)
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const legacyPage = params.get('page');
    if (legacyPage && PAGE_ROUTES[legacyPage]) {
      navigate(PAGE_ROUTES[legacyPage], { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // --- مدیریت سشن کاربر (Check LocalStorage) ---
  useEffect(() => {
    const storedUser = localStorage.getItem('arkani_user');
    if (storedUser) {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);
        setUserProfile({ username: parsedUser.full_name }); 
    }
  }, []);

  const handleOpenAuth = (mode = 'login') => {
    setAuthMode(mode);
    setShowAuthModal(true);
    setAuthEmail('');
    setAuthPassword('');
    setAuthUsername('');
    setAuthLoading(false);
    setAuthShowPass(false);
  };

  const handleSignOut = () => {
    localStorage.removeItem('arkani_user');
    setUser(null);
    setUserProfile(null);
    alert('با موفقیت خارج شدید');
  };

  // --- مدیریت لاگین، ثبت نام و فراموشی رمز عبور با PHP API ---
  const handleAuth = async (e) => {
    e.preventDefault();
    setAuthLoading(true);

    try {
      let action = 'login';
      if (authMode === 'signup') action = 'signup';
      else if (authMode === 'forgot') action = 'forgot_password';

      const bodyData = {
          action: action,
          email: authEmail,
          password: authPassword,
          full_name: authUsername
      };

      // در حالت forgot_password فقط ایمیل لازم است
      if (authMode === 'forgot') {
        bodyData.password = undefined; // اختیاری، اما نیاز نیست
      }

      const response = await fetch(`${API_BASE}/users.php`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(bodyData)
      });

      const result = await response.json();

      if (!result.success) {
          throw new Error(result.error || 'خطایی رخ داد');
      }

      // مدیریت پاسخ بر اساس حالت
      if (authMode === 'forgot') {
          alert(result.message || 'رمز عبور موقت به ایمیل شما ارسال شد. لطفاً ایمیل خود را بررسی کنید.');
          setAuthMode('login'); // بازگشت به حالت لاگین
      } else if (authMode === 'signup') {
          alert('ثبت نام موفقیت آمیز بود. لطفا وارد شوید.');
          setAuthMode('login');
          // پاکسازی فرم ثبت نام
          setAuthEmail('');
          setAuthPassword('');
          setAuthUsername('');
      } else {
          // لاگین موفق
          setUser(result.user);
          setUserProfile({ username: result.user.full_name });
          localStorage.setItem('arkani_user', JSON.stringify(result.user));
          
          setShowAuthModal(false);
          setAuthEmail('');
          setAuthPassword('');
          setAuthUsername('');
      }

    } catch (error) {
      alert(error.message || 'خطا در ارتباط با سرور');
    } finally {
      setAuthLoading(false);
    }
  };

  // --- Fetch Data from PHP API ---
  const fetchData = async () => {
    setIsLoadingData(true);
    try {
      // دریافت اخبار
      const newsRes = await fetch(`${API_BASE}/news.php`);
      const newsData = await newsRes.json();

      // دریافت نظرات تایید شده
      const commentsRes = await fetch(`${API_BASE}/comments.php?approved=1`);
      const commentsData = await commentsRes.json();

      if (Array.isArray(newsData)) setNews(newsData);
      if (Array.isArray(commentsData)) setComments(commentsData);

    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setIsLoadingData(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // هر بار صفحه‌ی تالار باز شد، نظرات و پاسخ‌های جدید دوباره گرفته می‌شود
  useEffect(() => {
    if (location.pathname !== '/forum') return;
    fetch(`${API_BASE}/comments.php?approved=1`)
      .then(r => r.json())
      .then(d => { if (Array.isArray(d)) setComments(d); })
      .catch(() => {});
  }, [location.pathname]);

  // --- Add Comment Handler (PHP) ---
  // parentId: اگر پاسخ به یک پیام است، شناسه‌ی همان پیام. خروجی: true در صورت موفقیت
  const handleAddComment = async (text, parentId = null) => {
    if (!user) return false;
    
    setIsSubmitting(true);
    const senderName = userProfile?.username || 'کاربر';

    try {
      const response = await fetch(`${API_BASE}/comments.php`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
              user_id: user.id,
              name: senderName,
              text: text,
              parent_id: parentId
          })
      });
      
      const result = await response.json();
      if (!result.success) throw new Error(result.error);

      alert(parentId
        ? 'پاسخ شما ثبت شد و پس از تایید مدیریت نمایش داده می‌شود.'
        : 'نظر شما با موفقیت ثبت شد و پس از تایید مدیریت نمایش داده می‌شود.');
      return true;
    } catch (error) {
      alert('خطا در ارسال پیام: ' + error.message);
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  // --- Add News Handler (Admin) ---
  const handleAddNews = async ({ title, text }) => {
    setIsNewsSubmitting(true);
    try {
      const response = await fetch(`${API_BASE}/news.php`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
              title,
              text,
              author: 'مدیریت'
          })
      });

      const result = await response.json();
      if (!result.success) throw new Error(result.error);

      // رفرش لیست اخبار
      fetchData(); 
    } catch (error) {
      alert('خطا در انتشار خبر: ' + error.message);
    } finally {
      setIsNewsSubmitting(false);
    }
  };

  // --- Delete News Handler ---
  const handleDeleteNews = async (id) => {
    if (!window.confirm('آیا مطمئن هستید؟')) return;
    try {
      const response = await fetch(`${API_BASE}/news.php`, {
          method: 'DELETE',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id })
      });
      const result = await response.json();
      if (!result.success) throw new Error(result.error);

      setNews(news.filter(item => item.id !== id));
    } catch (error) {
      alert('خطا در حذف: ' + error.message);
    }
  };

  const handleDeleteComment = async (id) => {
     // This is handled in LoginAdmin mostly
  };

  const Footer = () => (
	  <footer className="bg-slate-900 border-t border-slate-800 py-6 text-center text-slate-500 text-xs relative z-20">
		<div className="container mx-auto px-4 flex flex-col items-center gap-3">
		  <p>© ۲۰۲۴ ارکانی عمران. تمامی حقوق محفوظ است.</p>
		  <a href="https://t.me/arkaniomran" className="hover:text-yellow-500 transition-colors">پشتیبانی: @arkaniomran</a>
		  <a referrerPolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=728986&Code=GUN8ovNUf0LWdqu2s43O89qy0NlWpTFu">
			<img
			  referrerPolicy="origin"
			  src="https://trustseal.enamad.ir/logo.aspx?id=728986&Code=GUN8ovNUf0LWdqu2s43O89qy0NlWpTFu"
			  alt="نماد اعتماد الکترونیکی"
			  style={{ cursor: 'pointer' }}
			  width="80"
			  height="80"
			/>
		  </a>
		</div>
	  </footer>
	);

  return (
    <div dir="rtl" className="antialiased flex flex-col min-h-screen bg-[#020617] text-white overflow-hidden relative font-sans">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Vazirmatn:wght@300;400;500;700;900&display=swap');
        @import url('https://fonts.googleapis.com/css?family=Raleway:400,700');

        ::-webkit-scrollbar { width: 8px; }
        ::-webkit-scrollbar-track { background: #0f172a; }
        ::-webkit-scrollbar-thumb { background: #334155; border-radius: 4px; }
        ::-webkit-scrollbar-thumb:hover { background: #475569; }

        .glass-panel {
			background: rgba(30, 41, 59, 0.7);
			-webkit-backdrop-filter: blur(12px); /* این خط اضافه شود */
			backdrop-filter: blur(12px);
			border: 1px solid rgba(255, 255, 255, 0.1);
		}

        .deep-hover {
            transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
            transform-style: preserve-3d;
        }
        .deep-hover:hover {
            transform: translateY(-8px) scale(1.01);
            box-shadow: 
                0 20px 30px -10px rgba(0, 0, 0, 0.6),
                0 0 15px rgba(255, 255, 255, 0.05) inset;
            z-index: 20;
            border-color: rgba(234, 179, 8, 0.4);
        }

        .hero-pattern {
            background-image: radial-gradient(#334155 1px, transparent 1px);
            background-size: 40px 40px;
            opacity: 0.1;
        }

        .fade-in { animation: fadeIn 0.5s ease-out forwards; }
        @keyframes fadeIn {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
        }

        .hidden-page { display: none !important; }

        .app-sidebar-item.active {
            background-color: rgba(234, 179, 8, 0.1);
            color: #eab308;
            border-right: 3px solid #eab308;
            font-weight: bold;
        }
        
        .custom-scrollbar::-webkit-scrollbar {
            width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
            background: rgba(15, 23, 42, 0.5);
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
            background: #475569;
            border-radius: 3px;
        }
        
        #app-container button:not(.close-btn):not(.app-sidebar-item) {
             background-color: #10b981;
             color: white;
             border: none;
             padding: 0.5rem 1rem;
             border-radius: 0.5rem;
             cursor: pointer;
             transition: all 0.2s;
             font-family: 'Vazirmatn', sans-serif;
        }
        #app-container button:not(.close-btn):not(.app-sidebar-item):hover {
             background-color: #059669;
             transform: translateY(-2px);
        }

        .note-card {
            transition: all 0.3s ease;
            border-radius: 24px;
            overflow: hidden;
            background: rgba(30, 41, 59, 0.4);
            border: 1px solid rgba(255, 255, 255, 0.05);
            display: flex;
            flex-direction: column;
            height: 100%;
        }
        .note-card:hover {
            transform: translateY(-5px);
            background: rgba(30, 41, 59, 0.8);
            border-color: rgba(234, 179, 8, 0.3);
            box-shadow: 0 10px 30px -10px rgba(0, 0, 0, 0.5);
        }
        .line-clamp-3 {
            overflow: hidden;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 3;
        }

        .modal-backdrop {
			background-color: rgba(0, 0, 0, 0.8);
			-webkit-backdrop-filter: blur(5px); /* این خط اضافه شود */
			backdrop-filter: blur(5px);
		}
        .modal-content {
            animation: modalPop 0.3s ease-out forwards;
        }
        @keyframes modalPop {
            from { opacity: 0; transform: scale(0.95); }
            to { opacity: 1; transform: scale(1); }
        }

        .custom-login-modal {
            font-family: Raleway, 'Vazirmatn', sans-serif;
        }

        .custom-login-modal .screen {		
            background: linear-gradient(90deg, #5D54A4, #7C78B8);		
            position: relative;	
            min-height: 580px; 
            height: auto; 
            max-height: 90vh; 
            width: 360px;
            max-width: 90vw; 
            box-shadow: 0px 0px 24px #5C5696;
            border-radius: 10px;
            overflow-y: auto; 
            overflow-x: hidden; 
            display: flex;
            flex-direction: column;
        }

        .custom-login-modal .screen__content {
            z-index: 1;
            position: relative;	
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }

        .custom-login-modal .screen__background {		
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            z-index: 0;
            -webkit-clip-path: inset(0 0 0 0);
            clip-path: inset(0 0 0 0);	
            pointer-events: none; 
        }

        .custom-login-modal .screen__background__shape {
            transform: rotate(45deg);
            position: absolute;
        }

        .custom-login-modal .screen__background__shape1 {
            height: 520px;
            width: 520px;
            background: #FFF;	
            top: -50px;
            right: 120px;	
            border-radius: 0 72px 0 0;
        }

        .custom-login-modal .screen__background__shape2 {
            height: 220px;
            width: 220px;
            background: #6C63AC;	
            top: -172px;
            right: 0;	
            border-radius: 32px;
        }

        .custom-login-modal .screen__background__shape3 {
            height: 540px;
            width: 190px;
            background: linear-gradient(270deg, #5D54A4, #6A679E);
            top: -24px;
            right: 0;	
            border-radius: 32px;
        }

        .custom-login-modal .screen__background__shape4 {
            height: 400px;
            width: 200px;
            background: #7E7BB9;	
            top: 420px;
            right: 50px;	
            border-radius: 60px;
        }

        .custom-login-modal .login {
            width: 100%;
            padding: 30px;
            padding-top: 120px; 
            flex-grow: 1; 
        }

        .custom-login-modal .login__field {
            padding: 20px 0px;	
            position: relative;	
        }

        .custom-login-modal .login__icon {
            position: absolute;
            top: 32px;
            right: 10px; 
            color: #fff; 
            opacity: 0.9;
            z-index: 10;
        }

        .custom-login-modal .login__eye {
            position: absolute;
            top: 32px;
            left: 10px; 
            color: #fff;
            opacity: 0.9;
            cursor: pointer;
            transition: color 0.2s;
            z-index: 10;
        }
        .custom-login-modal .login__eye:hover {
            color: #5D54A4;
        }

        .custom-login-modal .login__input {
            border: none;
            border-bottom: 2px solid #D1D1D4;
            background: rgba(0, 0, 0, 0.35); 
			-webkit-backdrop-filter: blur(5px); /* این خط اضافه شود */
            backdrop-filter: blur(5px); 
            border-radius: 8px; 
            padding: 12px;
            padding-right: 40px; 
            font-weight: 700;
            width: 100%;
            transition: .2s;
            color: #fff; 
            margin-bottom: 5px;
        }

        .custom-login-modal .login__input:active,
        .custom-login-modal .login__input:focus,
        .custom-login-modal .login__input:hover {
            outline: none;
            border-bottom-color: #6A679E;
            background: rgba(0, 0, 0, 0.5); 
            color: #fff;
        }

        .custom-login-modal .login__submit {
            background: #fff;
            font-size: 14px;
            margin-top: 20px;
            padding: 16px 20px;
            border-radius: 26px;
            border: 1px solid #D4D3E8;
            text-transform: uppercase;
            font-weight: 700;
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            color: #4C489D;
            box-shadow: 0px 2px 2px #5C5696;
            cursor: pointer;
            transition: .2s;
        }

        .custom-login-modal .login__submit:active,
        .custom-login-modal .login__submit:focus,
        .custom-login-modal .login__submit:hover {
            border-color: #6A679E;
            outline: none;
        }

        .custom-login-modal .button__icon {
            font-size: 24px;
            margin-right: auto; 
            margin-left: 0;
            color: #7875B5;
        }

        .custom-login-modal .social-login {	
            position: relative; 
            height: auto;
            width: 100%;
            text-align: center;
            padding: 20px;
            margin-top: auto; 
            color: #fff;
            z-index: 2;
        }

        .custom-login-modal .forgot-link {
            color: rgba(255,255,255,0.8);
            font-size: 12px;
            margin-top: 10px;
            cursor: pointer;
            text-decoration: underline;
            text-underline-offset: 3px;
        }
        .custom-login-modal .forgot-link:hover {
            color: #FFD700;
        }

        @media (max-width: 480px) {
            .custom-login-modal .screen {
                 min-height: auto; 
            }
        }
      `}</style>

      {/* ===== SEO: تایتل و متا تگ مخصوص هر صفحه ===== */}
      <Helmet>
        <title>{(SEO_META[activePage] || SEO_META.home).title}</title>
        <meta name="description" content={(SEO_META[activePage] || SEO_META.home).description} />
        <link rel="canonical" href={`https://arkaniomran.ir${location.pathname}`} />
        {(activePage === 'admin-panel' || activePage === 'reseller-panel') ? (
          <meta name="robots" content="noindex, nofollow" />
        ) : (
          <meta name="robots" content="index, follow" />
        )}
      </Helmet>

      {/* ===== HEADER ===== */}
      <HeaderNavigation
        activePage={activePage}
        onNavigate={handleNavigate}
        user={user}
        userProfile={userProfile}
        onSignOut={handleSignOut}
        onOpenAuth={handleOpenAuth}
        mobileMenuHidden={mobileMenuHidden}
        setMobileMenuHidden={setMobileMenuHidden}
        Icons={Icons}
      />

      {/* ===== MAIN CONTENT ===== */}
      <main className={`flex-grow overflow-y-auto ${activePage === 'admin-panel' ? '' : 'pt-16 md:pt-20'} pb-16 relative`}>
        <Routes>
          <Route path="/" element={
            <Home isVisible={true} onNavigate={handleNavigate} Icons={Icons} />
          } />

          <Route path="/etabs-training" element={
            <EtabsTraining isVisible={true} onNavigate={handleNavigate} Icons={Icons} />
          } />

          <Route path="/etabs-concrete-training" element={
            <EtabsConcreteTraining isVisible={true} onNavigate={handleNavigate} Icons={Icons} />
          } />

          <Route path="/safe-training" element={
            <SafeTraining isVisible={true} onNavigate={handleNavigate} Icons={Icons} />
          } />

          <Route path="/idea-statica-training" element={
            <IdeaStaticaTraining isVisible={true} onNavigate={handleNavigate} Icons={Icons} />
          } />

          <Route path="/rhino-training" element={
            <RhinoGrasshopperTraining isVisible={true} onNavigate={handleNavigate} Icons={Icons} />
          } />

          <Route path="/about" element={
            <AboutUs isVisible={true} onBack={() => handleNavigate('home')} />
          } />

          <Route path="/news" element={
            <News isVisible={true} news={news} isLoadingData={isLoadingData} Icons={Icons} />
          } />

          <Route path="/products/:productName" element={
            <ProductPageRoute Icons={Icons} />
          } />

          <Route path="/forum" element={
            <FreeDiscussion
              isVisible={true}
              user={user}
              userProfile={userProfile}
              comments={comments}
              isLoadingData={isLoadingData}
              onAddComment={handleAddComment}
              isSubmitting={isSubmitting}
              onShowAuth={() => handleOpenAuth('login')}
              Icons={Icons}
            />
          } />

          <Route path="/free-apps" element={
            <FreeApps isVisible={true} appVersion={APP_VERSION} Icons={Icons} Footer={Footer} />
          } />

          <Route path="/admin-panel" element={
            <LoginAdmin
              isVisible={true}
              isAdmin={isAdmin}
              setIsAdmin={setIsAdmin}
              onBack={() => handleNavigate('home')}
              news={news}
              comments={comments}
              onAddNews={handleAddNews}
              onDeleteNews={handleDeleteNews}
              onDeleteComment={handleDeleteComment}
              isNewsSubmitting={isNewsSubmitting}
              Icons={Icons}
              API_BASE={API_BASE}
            />
          } />

          <Route path="/activation" element={<ActivationForm isVisible={true} />} />

          <Route path="/reseller-panel" element={
            <ResellerPanel isVisible={true} onBack={() => handleNavigate('home')} API_BASE={API_BASE} Icons={Icons} />
          } />

          {/* هر آدرس ناشناخته به صفحه اصلی برمی‌گردد */}
          <Route path="*" element={
            <Home isVisible={true} onNavigate={handleNavigate} Icons={Icons} />
          } />
        </Routes>
      </main>

      {activePage !== 'admin-panel' && activePage !== 'free-apps' && <Footer />}

      {/* Modal Authentication (Login / Sign Up / Forgot Password) */}
      {showAuthModal && (
        <div className="fixed inset-0 z-[100] modal-backdrop flex items-center justify-center p-4 custom-login-modal" onClick={() => setShowAuthModal(false)}>
          <div className="screen" onClick={e => e.stopPropagation()}>
            <div className="screen__content">
              <button aria-label="بستن پنجره" onClick={() => setShowAuthModal(false)} className="absolute top-4 left-4 z-50 text-white/50 hover:text-white transition-colors">
                <Icons.X size={24} />
              </button>

              <form onSubmit={handleAuth} className="login">
                <div className="text-center mb-6">
                  <h3 className="text-2xl font-bold text-[#4C489D] mb-1">
                    {authMode === 'login' ? 'ورود' : authMode === 'signup' ? 'ثبت نام' : 'فراموشی رمز'}
                  </h3>
                  <p className="text-xs text-[#7875B5]">
                    {authMode === 'login' 
                      ? 'خوش آمدید! لطفا وارد شوید' 
                      : authMode === 'signup' 
                        ? 'عضو جدید؟ همین حالا ثبت نام کنید'
                        : 'ایمیل خود را برای دریافت رمز جدید وارد کنید'}
                  </p>
                </div>

                {/* فیلد نام کامل (فقط در حالت ثبت نام) */}
                {authMode === 'signup' && (
                  <div className="login__field">
                    <Icons.User className="login__icon" />
                    <input 
                      type="text" 
                      className="login__input" 
                      placeholder="نام کامل"
                      required
                      value={authUsername}
                      onChange={(e) => setAuthUsername(e.target.value)}
                    />
                  </div>
                )}

                {/* فیلد ایمیل (در همه حالات) */}
                <div className="login__field">
                  <Icons.MessageSquare className="login__icon" />
                  <input 
                    type="email" 
                    className="login__input dir-ltr text-right placeholder-right" 
                    placeholder="ایمیل" 
                    required
                    value={authEmail}
                    onChange={(e) => setAuthEmail(e.target.value)}
                    style={{ direction: 'ltr', textAlign: 'right' }} 
                  />
                </div>

                {/* فیلد رمز عبور (فقط در لاگین و ثبت نام) */}
                {authMode !== 'forgot' && (
                  <div className="login__field">
                    <Icons.Lock className="login__icon" />
                    <input 
                      type={authShowPass ? "text" : "password"} 
                      className="login__input dir-ltr text-right placeholder-right" 
                      placeholder="رمز عبور"
                      required={authMode !== 'forgot'}
                      value={authPassword}
                      onChange={(e) => setAuthPassword(e.target.value)}
                      style={{ direction: 'ltr', textAlign: 'right' }}
                    />
                    {authShowPass ? (
                      <Icons.EyeOff className="login__eye" onClick={() => setAuthShowPass(false)} />
                    ) : (
                      <Icons.Eye className="login__eye" onClick={() => setAuthShowPass(true)} />
                    )}
                  </div>
                )}

                <button className="login__submit" disabled={authLoading}>
                  <span className="button__text">
                    {authLoading ? 'در حال پردازش...' : 
                      authMode === 'login' ? 'ورود به حساب' : 
                      authMode === 'signup' ? 'ثبت نام در سایت' : 
                      'ارسال رمز جدید'}
                  </span>
                  <Icons.ChevronLeft className="button__icon" />
                </button>

                {/* لینک فراموشی (فقط در حالت لاگین) */}
                {authMode === 'login' && (
                  <div className="text-center mt-2">
                    <button 
                      type="button"
                      onClick={() => setAuthMode('forgot')}
                      className="forgot-link"
                    >
                      رمز عبور را فراموش کرده‌اید؟
                    </button>
                  </div>
                )}
              </form>

              <div className="social-login">
                {/* در حالت forgot دکمه برگشت به لاگین */}
                {authMode === 'forgot' ? (
                  <button 
                    onClick={() => setAuthMode('login')}
                    className="text-white font-bold text-sm hover:underline cursor-pointer"
                  >
                    بازگشت به صفحه ورود
                  </button>
                ) : (
                  <button 
                    onClick={() => setAuthMode(authMode === 'login' ? 'signup' : 'login')}
                    className="text-white font-bold text-sm hover:underline cursor-pointer"
                  >
                    {authMode === 'login' ? 'حساب ندارید؟ ثبت نام' : 'ورود به حساب کاربری'}
                  </button>
                )}
              </div>
            </div>

            <div className="screen__background">
              <span className="screen__background__shape screen__background__shape4"></span>
              <span className="screen__background__shape screen__background__shape3"></span>		
              <span className="screen__background__shape screen__background__shape2"></span>
              <span className="screen__background__shape screen__background__shape1"></span>
            </div>		
          </div>
        </div>
      )}
    </div>
  );
};

// کامپوننت اصلی: Provider های روتینگ و سئو را فراهم می‌کند
// (منطق اصلی برنامه داخل AppContent است تا بتواند از useNavigate/useLocation استفاده کند)
const App = () => (
  <HelmetProvider>
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  </HelmetProvider>
);

export default App;